import React from "react";
import { Route, Routes } from "react-router-dom";

import Variations from "@/components/screens/Variations";
import VariationsFormPage from "@/components/screens/VariationsFormPage";
import { VARIATION_FORM_PAGE_MESSAGES } from "@/messages/variation/variations-form-page.messages";
import { VARIATIONS_MESSAGES } from "@/messages/variation/variations.messages";

const ProductVariationsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Variations messages={VARIATIONS_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<VariationsFormPage messages={VARIATION_FORM_PAGE_MESSAGES} />}
      />
      <Route
        path="/update/:variationId/:lang"
        element={<VariationsFormPage messages={VARIATION_FORM_PAGE_MESSAGES} isEditing />}
      />
      <Route path="/" element={<Variations messages={VARIATIONS_MESSAGES} />} />
    </Routes>
  );
};

export default ProductVariationsPage;
